import type { StateCreator } from 'zustand';
import type { ChatSelectionSlice, WhatsAppChatStore } from '../types';
import { debugLog } from '../../../../components/whatsapp2/chat/ChatDebugPanel';

export const createChatSelectionSlice: StateCreator<
  WhatsAppChatStore,
  [],
  [],
  ChatSelectionSlice
> = (set, get) => ({
  selectedChatId: null,
  selectedChatData: null,

  selectChat: (chatId: string | null) => {
    const selectedChatData = chatId
      ? get().chats.find(c => c.id === chatId) || null
      : null;
    if (chatId) {
      debugLog('SelectChat', `→ "${selectedChatData?.name || chatId.slice(0, 25)}" | isGroup:${selectedChatData?.isGroup} | unread:${selectedChatData?.unreadCount || 0} | hasPic:${!!selectedChatData?.profilePicUrl}`);
    }

    // Azzera unreadCount sulla chat selezionata (lo stato persistito è gestito
    // da sendReadReceipt → mark_whatsapp_chat_as_read RPC chiamato sotto)
    const updatedChats = chatId
      ? get().chats.map(c => c.id === chatId ? { ...c, unreadCount: 0 } : c)
      : get().chats;

    set({
      selectedChatId: chatId,
      selectedChatData,
      chats: updatedChats,
      messages: [],
      messagesError: null,
      hasOlderMessages: true,
      oldestMessageTimestamp: null,
      wahaOffset: 0,
      replyingTo: null,
    });

    // Persisti lo stato "letta" (DB + WAHA) — fire-and-forget
    // Aprire una chat = leggerla ovunque (cross-device sync)
    if (chatId && !selectedChatData?.isDraft) {
      get().sendReadReceipt(chatId);
    }
  },
});
